<template>
  <div id="app">
    <!-- 路由出口，用于显示路由匹配的组件 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
    // 这里可以注册全局组件
  },
  data() {
    return {
      // 这里可以定义组件的数据
    }
  },
  methods: {
    // 这里可以定义组件的方法
  },
  created() {
    // 组件创建时的生命周期钩子
  },
  mounted() {
    // 组件挂载到 DOM 后的生命周期钩子
  }
}
</script>

<style>
@import '@/assets/styles/global.css';
/*每个页面公共css */
	/* 引入 iconfont 字体图标 */
@import url('https://at.alicdn.com/t/c/font_4924960_ep7cpxhwx.css');

html, body, #app {
  height: 100%;
  background: #f5f6fa;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

.el-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  border: none;
}

.el-table th, .el-table td {
  font-size: 14px;
}

.el-button {
  border-radius: 4px;
}

.el-form-item {
  margin-bottom: 16px;
}

.el-pagination {
  margin-top: 16px;
}

/* 侧边栏优化 */
.el-menu {
  background: #263445 !important;
  color: #bfcbd9 !important;
}
.el-menu-item.is-active {
  background: #409EFF !important;
  color: #fff !important;
}
.el-menu-item, .el-submenu__title {
  color: #bfcbd9 !important;
}

/* 面包屑优化 */
.el-breadcrumb__item {
  font-size: 14px;
}

/* 卡片内边距统一 */
.el-card__body {
  padding: 20px;
}
</style> 